import * as Yup from 'yup';

/**
 * Converts Yup validation errors to a flat Record<string, string> format
 * with field paths as keys (e.g., "address.street")
 *
 * @param error - The Yup ValidationError to flatten
 * @param prefix - Optional prefix to prepend to all field paths (e.g., "address")
 * @returns A flat object mapping field paths to error messages
 */
export const flattenYupErrors = (error: Yup.ValidationError, prefix: string = ''): Record<string, string> => {
  const errors: Record<string, string> = {};
  if (error.inner && error.inner.length > 0) {
    error.inner.forEach(err => {
      const path = prefix ? `${prefix}.${err.path}` : err.path || '';
      if (path && err.message) {
        errors[path] = err.message;
      }
    });
  } else if (error.path && error.message) {
    const path = prefix ? `${prefix}.${error.path}` : error.path;
    errors[path] = error.message;
  }
  return errors;
};
